/*
 * Datazoom, Inc ("COMPANY") CONFIDENTIAL
 * Copyright (c) 2017-2018 [Datazoom, Inc.], All Rights Reserved.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */

import { DATAPIPE_STATUS } from "../../app/Constants/Constants";
import { addCustomEvent } from "../../app/Utilities/utils";
import {
  SUPER_ADMIN_ROLE,
  CUSTOM_DATA_GROUP,
  CON_IMG_URL,
} from "../../constants/Constants";

//
//  HERE KEY IS GIVEN IN ACCORDANCE WITH FIELD KEY TO BE PASSED WHEN SORTING THE CORRESPONDING FIELD ─────
//

export const filterBoxData = /* istanbul ignore next */ (
  companies,
  currentRole,
  roles,
) => {
  const DPList = [
    {
      name: "Status",
      DPValue: DATAPIPE_STATUS.sort().map(
        /* istanbul ignore next */ (status) => {
          return {
            id: Math.random().toString(36).slice(2, 7),
            name: status.name,
            value: status.value,
            type: "status",
          };
        },
      ),
    },
  ];
  return {
    DPList,
  };
};
export const filterDefaultData = () => {
  return {
    id: Math.random().toString(36).slice(2, 7),
    name: "Active",
    type: "status",
  };
};
export const titles = [
  {
    key: "status",
    label: "Status",
  },
  {
    key: "title",
    label: "Name",
    sortable: true,
    sortKey: "title",
  },
  {
    key: "collectors",
    label: "Collectors",
  },
  {
    key: "connectors",
    label: "Connectors",
  },
];

export const getListViewObj = (datapipe, auth) => {
  const obj = {
    key: datapipe.id,
    status: {
      value: datapipe.disabled,
      view: "status",
    },
    title: {
      value: datapipe.title,
    },
    collectors: {
      value: datapipe.collectors.length || 0,
    },
    connectors: {
      value: datapipe.connectors.length || 0,
    },
    hideFromCustomer: {
      value: datapipe?.hideFromCustomer,
    },
  };
  /* istanbul ignore else */
  if (auth && auth.user && auth.user.roleName === SUPER_ADMIN_ROLE) {
    obj.company = {
      value: datapipe.companyName,
    };
  }
  return obj;
};
export const connectorDataPipeBO = /* istanbul ignore next */ (
  connector,
  player,
) => ({
  connectorId: connector.connectorId,
  dzConnectorId: connector.dzConnectorId,
  connectorName: connector.connectorName,
  icon: connector.icon,
  id: connector.id,
  connectorConfigName: connector.name,
  disabled: connector.disabled,
  dzInternal: connector.dzInternal,
  convertToDdv2: connector.convertToDdv2,
  iconUrl: CON_IMG_URL + connector.icon,
});
export const collectorDataPipeBO = /* istanbul ignore next */ (
  collector,
  player,
) => ({
  collectorId: collector.playerId,
  collectorName: player.name,
  configId: collector.id,
  configName: collector.name,
  disabled: collector.disabled,
  icon: collector.icon,
  platformIcon: collector.platformIcon,
  playHeadFrequency: collector.playHeadFrequency,
  collectorType: player.collectorType,
  eventList: player.eventList.map((event) => ({
    id: event.id,
    dictionaryVersionDatapointMappingId: event.id,
    name: event.name,
    label: event.label,
    deprecated: event.deprecated,
    supportedMediaTypes: event.supportedMediaTypes,
    required: event.required,
    selected: true,
  })),
  fluxDataList: player.fluxDataList.map((flux) => ({
    id: flux.id,
    dictionaryVersionDatapointMappingId: flux.id,
    name: flux.name,
    label: flux.label,
    deprecated: flux.deprecated,
    required: flux.required,
    selected: true,
  })),
  metaDataList: player.metaDataList.map((meta) => ({
    id: meta.id,
    dictionaryVersionDatapointMappingId: meta.id,
    name: meta.name,
    label: meta.label,
    deprecated: meta.deprecated,
    required: meta.required,
    selected: true,
  })),
});
export const collectorDataPipeFromInnerGridBO = /* istanbul ignore next */ (
  collector,
  playerData,
) => {
  const eventList = [];
  const fluxDataList = [];
  const metaDataList = [];
  playerData.forEach((data) => {
    if (!data.id) return;
    switch (data.label) {
      case "event":
        eventList.push({
          id: data.id,
          dictionaryVersionDatapointMappingId: data.id,
          name: data.name,
          label: data.label,
          deprecated: data.deprecated,
          required: data.required,
          selectedMediaTypes: data.selectedMediaTypes,
          supportedMediaTypes: data.supportedMediaTypes,
          selected: data.selected,
        });
        break;
      case "fluxdata":
        fluxDataList.push({
          id: data.id,
          dictionaryVersionDatapointMappingId: data.id,
          name: data.name,
          label: data.label,
          deprecated: data.deprecated,
          required: data.required,
          selected: data.selected,
        });
        break;
      case "metadata":
        metaDataList.push({
          id: data.id,
          dictionaryVersionDatapointMappingId: data.id,
          name: data.name,
          label: data.label,
          deprecated: data.deprecated,
          required: data.required,
          selected: data.selected,
        });
        break;
      default:
        break;
    }
  });

  return {
    collectorId: collector.collectorId,
    collectorName: collector.collectorName,
    configId: collector.configId,
    configName: collector.configName,
    disabled: collector.disabled,
    eventList,
    fluxDataList,
    icon: collector.icon,
    metaDataList,
    platformIcon: collector.platformIcon,
    playHeadFrequency: collector.playHeadFrequency,
    collectorType: collector.collectorType,
  };
};
export const collectorDataPipeFromInnerGridBO_V2 = (collector, playerData) => {
  const result = {
    collectorIcon: collector.collectorIcon,
    collectorId: collector.collectorId,
    collectorName: collector.collectorName,
    configId: collector.configId,
    configName: collector.configName,
    disabled: collector.disabled,
    general: { eventList: [], fluxDataList: [], metaDataList: [] },
    custom: [],
    vendor: [],
    pluginIcon: collector.pluginIcon,
    pluginId: collector.pluginId,
    pluginName: collector.pluginName,
    plugin: collector.plugin,
    dataPointList: [],
  };
  if (collector.plugin)
    result.mediaPlayer = {
      eventList: [],
      fluxDataList: [],
      metaDataList: [],
    };
  playerData.forEach((data) => {
    let {
      mainGroup,
      group,
      datapointsList,
      originalId,
      subGroup,
      dataPointId,
      name,
      deprecated,
      required,
      selectedMediaTypes,
      supportedMediaTypes,
      selected,
      label,
    } = data;
    mainGroup =
      mainGroup === "General"
        ? "general"
        : mainGroup === "Custom"
        ? "custom"
        : mainGroup === "Vendor"
        ? "vendor"
        : "mediaPlayer";
    if (group === "Events") {
      result[mainGroup].eventList.push({
        dataPointId,
        label,
        name,
        deprecated,
        required,
        selectedMediaTypes,
        supportedMediaTypes,
        selected,
        group,
        datapointsList,
        originalId,
      });
    } else if (group === "Fluxdata") {
      result[mainGroup].fluxDataList.push({
        dataPointId,
        label,
        name,
        deprecated,
        required,
        selected,
        group,
      });
    } else if (group === "Metadata") {
      result[mainGroup].metaDataList?.push({
        dataPointId,
        label,
        name,
        deprecated,
        required,
        selected,
        group: subGroup,
      });
    } else if (group === "Custom") {
      result?.custom?.push({
        dataPointId,
        label,
        name,
        deprecated,
        required,
        selected,
        group,
      });
    } else if (group === "Vendor") {
      result?.vendor?.push({
        dataPointId,
        label,
        name,
        deprecated,
        required,
        selected,
        group,
      });
    }
  });
  return result;
};

export const dataPipeBO = (datapipe) => {
  let obj = {};
  if (datapipe.id !== undefined) {
    obj.id = datapipe.id;
  }
  obj = {
    ...obj,
    name: datapipe.name,
    companyId: datapipe.companyId,
    collectorConfigs: datapipe.collectorConfigs.map((collectorConfig) => ({
      id: collectorConfig.configId,
      eventsList: collectorConfig.eventList
        .filter((eventList) => eventList.selected)
        .map((events) => ({
          id: events.dictionaryVersionDatapointMappingId,
          selectedMediaTypesArray: events.selectedMediaTypes,
        })),
      fluxDataList: collectorConfig.fluxDataList
        .filter((fluxDataList) => fluxDataList.selected)
        .map((flux) => ({
          id: flux.dictionaryVersionDatapointMappingId,
        })),
      metaDataList: collectorConfig.metaDataList
        .filter((metaDataList) => metaDataList.selected)
        .map((metadata) => ({
          id: metadata.dictionaryVersionDatapointMappingId,
        })),
    })),
    connectorConfigs: datapipe.connectorConfigs.map((connectorConfig) => ({
      id: connectorConfig.id,
    })),
  };
  return obj;
};
export const dataPipeBO_V2 = (datapipe) => {
  let obj = {};
  if (datapipe.id !== undefined) {
    obj.id = datapipe.id;
  }

  obj = {
    ...obj,
    name: datapipe.name,
    companyId: datapipe.companyId,
    collectorConfigs: datapipe.collectorConfigs.map((collectorConfig) => {
      const collectorData = {
        configId: collectorConfig.configId,
      };
      const general = {
        events: rearrangeGroupedDataV3(
          collectorConfig?.general?.eventList || [],
        ),
        fluxdata:
          collectorConfig?.general?.fluxDataList
            ?.filter((flux) => flux.selected || flux.required)
            .map((fluxData) => ({
              id: fluxData.dataPointId,
            })) || [],
        metadata:
          collectorConfig?.general?.metaDataList
            ?.filter((meta) => meta.selected || meta.required)
            .map((metaData) => ({
              id: metaData.dataPointId,
            })) || [],
      };
      collectorData.general = general;
      if (collectorConfig.plugin) {
        const mediaPlayer = {
          events: rearrangeGroupedDataV3(
            collectorConfig?.mediaPlayer?.eventList || [],
          ),
          fluxdata:
            collectorConfig?.mediaPlayer?.fluxDataList
              ?.filter((flux) => flux.selected || flux.required)
              .map((fluxData) => ({
                id: fluxData.dataPointId,
              })) || [],
          metadata:
            collectorConfig?.mediaPlayer?.metaDataList
              ?.filter((meta) => meta.selected || meta.required)
              .map((metadata) => ({
                id: metadata.dataPointId,
              })) || [],
        };
        if (
          mediaPlayer.events.length > 0 ||
          mediaPlayer.fluxdata.length > 0 ||
          mediaPlayer.metadata.length > 0
        ) {
          collectorData.mediaPlayer = mediaPlayer;
        }
      }
      const custom =
        collectorConfig?.custom
          ?.filter((cust) => cust.selected || cust.required)
          .map((customData) => ({
            id: customData.dataPointId,
          })) || [];
      if (custom.length > 0) {
        collectorData.custom = custom;
      }

      const vendor =
        collectorConfig?.vendor
          ?.filter((vendor) => vendor.selected || vendor.required)
          .map((venderData) => ({
            id: venderData.dataPointId,
          })) || [];
      if (vendor.length > 0) {
        collectorData.vendor = vendor;
      }
      return collectorData;
    }),
    connectorConfigs: datapipe.connectorConfigs.map((connectorConfig) => ({
      id: connectorConfig.id,
    })),
  };
  return obj;
};

const rearrangeGroupedDataV3 = (groupedData) => {
  const transformedData = [];
  groupedData.forEach((data) => {
    if (data?.datapointsList) {
      data?.datapointsList?.forEach((datapoint) => {
        transformedData.push({
          id: datapoint?.id,
          required: data.required,
          selected: datapoint.selected,
          selectedMediaType: datapoint.mediaTypeName,
        });
      });
    } else {
      transformedData.push({
        id: data?.dataPointId,
        required: data.required,
        selected: data.selected,
        selectedMediaType: data.mediaType,
      });
    }
  });
  const filteredData = transformedData
    .filter((item) => item.required === true || item.selected === true)
    .map(({ required, selected, ...rest }) => rest);
  return filteredData;
};

export const dataPipeCreate_BO_V2 = (datapipe) => {
  let obj = {};
  obj = {
    ...obj,
    name: datapipe.name,
    companyId: datapipe.companyId,
    collectorConfigs: datapipe.collectorConfigs.map((collectorConfig) => {
      const collectorData = {
        configId: collectorConfig.configId,
      };
      const general = {
        eventsList: rearrangeGroupedDataV3(
          collectorConfig?.general?.eventList || [],
        ),
        fluxDataList:
          collectorConfig?.general?.fluxDataList
            ?.filter((flux) => flux.selected || flux.required)
            .map((fluxData) => ({
              id: fluxData.dataPointId,
            })) || [],
        metaDataList:
          collectorConfig?.general?.metaDataList
            ?.filter((meta) => meta.selected || meta.required)
            .map((metaData) => ({
              id: metaData.dataPointId,
            })) || [],
      };
      // Only include `general` if it has data
      if (
        general.eventsList.length > 0 ||
        general.fluxDataList.length > 0 ||
        general.metaDataList.length > 0
      ) {
        collectorData.general = general;
      }
      if (collectorConfig.plugin) {
        const mediaPlayer = {
          eventsList: rearrangeGroupedDataV3(
            collectorConfig?.mediaPlayer?.eventList || [],
          ),
          fluxDataList:
            collectorConfig?.mediaPlayer?.fluxDataList
              ?.filter((flux) => flux.selected || flux.required)
              .map((fluxData) => ({
                id: fluxData.dataPointId,
              })) || [],
          metaDataList:
            collectorConfig?.mediaPlayer?.metaDataList
              ?.filter((meta) => meta.selected || meta.required)
              .map((metadata) => ({
                id: metadata.dataPointId,
              })) || [],
        };
        if (
          mediaPlayer.eventsList.length > 0 ||
          mediaPlayer.fluxDataList.length > 0 ||
          mediaPlayer.metaDataList.length > 0
        ) {
          collectorData.mediaPlayer = mediaPlayer;
        }
      }
      const custom =
        collectorConfig?.custom
          ?.filter((cust) => cust.selected || cust.required)
          .map((customData) => ({
            id: customData.dataPointId,
          })) || [];
      if (custom.length > 0) {
        collectorData.custom = custom;
      }

      const vendor =
        collectorConfig?.vendor
          ?.filter((vendor) => vendor.selected || vendor.required)
          .map((venderData) => ({
            id: venderData.dataPointId,
          })) || [];
      if (vendor.length > 0) {
        collectorData.vendor = vendor;
      }
      return collectorData;
    }),
    connectorConfigs: datapipe.connectorConfigs.map((connectorConfig) => ({
      id: connectorConfig.id,
    })),
  };
  return obj;
};
export const datapipeCustomEventBO = (datapipe) => {
  const datapipeResponse = datapipe;
  if (datapipeResponse?.collectorConfigs.length > 0) {
    datapipeResponse?.collectorConfigs?.forEach((collectorConfig) => {
      collectorConfig = addCustomEvent(collectorConfig);
    });
  }
  return datapipeResponse;
};
export const checkWarningBO = /* istanbul ignore next */ (datapipe) => {
  let obj = {};
  if (datapipe?.id !== undefined) {
    obj.id = datapipe.id;
  }
  obj = {
    ...obj,
    companyId: datapipe?.companyId,
    companyName: datapipe?.companyName,
    disabled: datapipe?.disabled,
    name: datapipe?.name,
    collectorConfigs: datapipe?.collectorConfigs?.map((collectorConfig) => ({
      id: collectorConfig.configId,
      eventsList: collectorConfig.eventList.map((event) => ({
        id: event.dictionaryVersionDatapointMappingId,
        selectedMediaTypesArray: event.selectedMediaTypes,
        selected: event.selected,
      })),
      fluxDataList: collectorConfig.fluxDataList.map((flux) => ({
        id: flux.dictionaryVersionDatapointMappingId,
        selected: flux.selected,
      })),
      metaDataList: collectorConfig.metaDataList.map((meta) => ({
        id: meta.dictionaryVersionDatapointMappingId,
        selected: meta.selected,
      })),
    })),
    connectorConfigs: datapipe?.connectorConfigs?.map((connectorConfig) => ({
      id: connectorConfig.id,
    })),
  };
  return obj;
};
export const checkWarningBO_V2 = /* istanbul ignore next */ (datapipe) => {
  let obj = {};
  if (datapipe?.id !== undefined) {
    obj.id = datapipe.id;
  }
  obj = {
    ...obj,
    companyId: datapipe?.companyId,
    companyName: datapipe?.companyName,
    disabled: datapipe?.disabled,
    name: datapipe?.name,
    collectorConfigs: datapipe?.collectorConfigs?.map((collectorConfig) => {
      return collectorConfig.listNode;
    }),
    connectorConfigs: datapipe?.connectorConfigs?.map((connectorConfig) => ({
      id: connectorConfig.id,
    })),
  };
  return obj;
};

export const extractLists = (
  obj,
  parentData = {},
  section = "general",
  isTopLevel = true,
  auth,
) => {
  if (!obj) return [];

  let result = [];
  const collectorTypeMap = new Map();

  if (isTopLevel) {
    const collectorConfigs = obj?.collectorConfigs || [];
    const allConfigNames = new Set(
      collectorConfigs.map(({ configName }) => configName),
    );

    collectorConfigs.forEach(({ configId, collectorType }) => {
      if (configId && collectorType) {
        collectorTypeMap.set(configId, collectorType);
      }
    });

    result = collectorConfigs.flatMap((config) =>
      extractLists(config, {}, section, false, auth),
    );

    return groupByLabel(result, allConfigNames, collectorConfigs, auth);
  }

  const resolvedConfigId = obj.configId ?? parentData.configId;
  const newParentData = {
    ...parentData,
    ...obj,
    configId: resolvedConfigId,
    section: section?.toLowerCase(),
    collectorType:
      obj.collectorType ??
      parentData.collectorType ??
      collectorTypeMap.get(resolvedConfigId),
  };

  Object.entries(obj).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      result.push(
        ...value.map((item) => ({
          ...newParentData,
          ...item,
          collectorType: item.collectorType ?? newParentData.collectorType,
          type: getTypeFromKey(key),
        })),
      );
    } else if (typeof value === "object" && value !== null) {
      const sectionMap = {
        mediaPlayer: "mediaPlayer",
        custom: "Custom",
        vendor: "Vendor",
        alias: "alias",
      };
      result.push(
        ...extractLists(
          value,
          newParentData,
          sectionMap[key] || section,
          false,
          auth,
        ),
      );
    }
  });

  return result;
};

function getTypeFromKey(key) {
  if (key === "eventList" || key === "events") return "event";
  if (key === "fluxDataList") return "fluxdata";
  if (key === "metaDataList" || key === "metadata") return "metadata";
  if (key === "custom") return "Custom";
  if (key === "vendor") return "Vendor";
  return "unknown";
}

function groupByLabel(data, allConfigNames, collectorConfigs, auth) {
  if (!data?.length) return null;
  const groupedData = {};
  const metadataGroups = {
    allMetadata: [],
    cdnMetadata: [],
    applicationMetadata: [],
  };

  const seenMetadataIds = new Set();

  data.forEach((item) => {
    const isCDN = item?.collectorType?.toLowerCase() === "cdn";
    const subkey = item?.type === "metadata" && isCDN ? "cdnMetadata" : "";
    const key = `${item?.name}_${item?.type}${subkey}` ?? "unknown";

    if (!groupedData[key]) {
      groupedData[key] = {
        ...removeUnwantedFields(item),
        exception_list: new Set(),
        includes_list: new Set(),
        type: item.type,
        selected: item?.selected,
        collectorType: item?.collectorType,
        supportedMediaTypes: new Set(),
        selectedMediaTypes: new Set(),
        group:
          item?.section === "alias" && item?.type === "metadata"
            ? "Custom metadata"
            : item?.group,
      };

      if (item.type === "event") {
        groupedData[key].additional_info = [];
      }
    }

    const isCustomOrVendor = item.type === "Custom" || item.type === "Vendor";

    if (isCustomOrVendor && item.label?.toLowerCase().includes("event")) {
      groupedData[key].type = "event";
      groupedData[key].originalType = item.type;
    } else if (
      isCustomOrVendor &&
      item.label?.toLowerCase().includes("metadata")
    ) {
      groupedData[key].group = item?.type;
      groupedData[key].originalType = item.type;
      groupedData[key].type = "metadata";

      const dpKey = item.dataPointId;
      if (!seenMetadataIds.has(dpKey)) {
        seenMetadataIds.add(dpKey);
        const metadataItem = {
          ...item,
          originalType: item.type,
          includes_list: groupedData[key].includes_list,
          exception_list: groupedData[key].exception_list,
        };
        if (isCDN) {
          metadataGroups.cdnMetadata.push(metadataItem);
        } else {
          metadataGroups.applicationMetadata.push(metadataItem);
        }
      }
    } else if (item.type === "metadata") {
      const dpKey = item.dataPointId;
      if (!seenMetadataIds.has(dpKey)) {
        seenMetadataIds.add(dpKey);
        const metadataItem = {
          ...item,
          includes_list: groupedData[key].includes_list,
          exception_list: groupedData[key].exception_list,
        };
        if (isCDN) {
          metadataGroups.cdnMetadata.push(metadataItem);
        } else {
          metadataGroups.applicationMetadata.push(metadataItem);
        }
      }
    } else if (item.type === "fluxdata") {
      groupedData[key].type = "fluxdata";
    }

    if (groupedData[key].type === "event") {
      const existing = groupedData[key]?.additional_info?.find(
        (info) =>
          info.dataPointId === item.dataPointId &&
          info.mediaType === item.mediaType,
      );

      if (existing) {
        if (!existing.configIds.includes(item.configId)) {
          existing.configIds.push(item.configId);
          if (item?.selected === true) {
            existing.selected = true;
            groupedData[key]?.selectedMediaTypes.add(item?.mediaType);
          }
        }
      } else {
        groupedData[key]?.additional_info?.push({
          dataPointId: item.dataPointId,
          name: item.name,
          label: item.label,
          required: item.required,
          deprecated: item.deprecated,
          selected: item.selected,
          mediaType: item.mediaType,
          configIds: [item?.configId],
        });
      }

      if (item.mediaType && item.mediaType !== "not_appl") {
        groupedData[key].supportedMediaTypes.add(item.mediaType);
        if (groupedData[key].selected === true) {
          groupedData[key].selectedMediaTypes.add(item.mediaType);
        }
      }
    }

    const relevantFields = extractRelevantFields(item);
    if (relevantFields.configId) {
      groupedData[key].includes_list.add(relevantFields);
    }
  });

  if (metadataGroups.cdnMetadata.length === 0) {
  }

  function processMetadataGroup(metadataGroup, type, collectorConfigs) {
    if (!Array.isArray(metadataGroup)) return [];

    return metadataGroup.map((item) => {
      const includesArray = Array.from(item.includes_list || []);
      item.includes_list = Array.from(
        new Map(includesArray.map((i) => [i.configId, i])).values(),
      );

      const currentConfigIds = new Set(
        item.includes_list.map((i) => i.configId),
      );
      item.exception_list = Array.isArray(collectorConfigs)
        ? collectorConfigs
            .filter(
              (cfg) => cfg?.configId && !currentConfigIds.has(cfg.configId),
            )
            .filter((cfg) => {
              const isCDN = cfg.collectorType?.toLowerCase() === "cdn";
              return type === "cdn" ? isCDN : !isCDN;
            })
            .map((cfg) => extractRelevantFields(cfg))
        : [];
      if (item?.includes_list?.some((e) => e?.selected || e?.required)) {
        item.selected = true;
      }
      if (item?.type === "Custom" && item?.originalType === "Custom") {
        item = filterCollectorListsByType(item, type);
      }
      return item;
    });
  }

  Object.keys(groupedData).forEach((key) => {
    const item = groupedData[key];

    groupedData[key].includes_list = Array.from(
      new Map(
        [...groupedData[key].includes_list].map((obj) => [obj.configId, obj]),
      ).values(),
    );

    const currentConfigIds = new Set(
      groupedData[key].includes_list.map((item) => item.configId),
    );

    groupedData[key].exception_list = Array.from(
      new Map(
        [...collectorConfigs]
          .filter(
            (config) =>
              config?.configId && !currentConfigIds.has(config.configId),
          )
          .map((config) => [config.configId, extractRelevantFields(config)]),
      ).values(),
    );

    if (groupedData[key].supportedMediaTypes.size > 0) {
      groupedData[key].supportedMediaTypes = Array.from(
        groupedData[key].supportedMediaTypes,
      );
      groupedData[key].selectedMediaTypes = Array.from(
        groupedData[key].selectedMediaTypes,
      );
    } else {
      delete groupedData[key].supportedMediaTypes;
      delete groupedData[key].selectedMediaTypes;
    }

    groupedData[key].selected = groupedData[key].includes_list.some(
      (item) => item.selected === true,
    );
  });

  metadataGroups.applicationMetadata = processMetadataGroup(
    metadataGroups.applicationMetadata,
    "application",
    collectorConfigs,
  );

  metadataGroups.cdnMetadata = processMetadataGroup(
    metadataGroups.cdnMetadata,
    "cdn",
    collectorConfigs,
  );

  const categorizedData = {
    event: [],
    metadata: {
      allMetadata: metadataGroups.allMetadata?.sort((a, b) =>
        a.name.localeCompare(b.name),
      ),
      cdnMetadata: metadataGroups.cdnMetadata?.sort((a, b) =>
        a.name.localeCompare(b.name),
      ),
      applicationMetadata: metadataGroups.applicationMetadata?.sort((a, b) =>
        a.name.localeCompare(b.name),
      ),
    },
    fluxdata: [],
    alias: {
      event: [],
      metaData: {
        applicationMetadata: [],
        cdnMetadata: [],
      },
    },
  };

  Object.values(groupedData).forEach((item) => {
    if (!item || typeof item !== "object") return;

    if (item.type === "event") {
      if (item?.section !== "alias") {
        categorizedData.event.push(item);
        categorizedData.event?.sort((a, b) => a.label.localeCompare(b.label));
      } else if (item?.section === "alias") {
        if (
          process.env.REACT_APP_CUSTOM_DATA === "true" &&
          auth?.user?.roleName === SUPER_ADMIN_ROLE
        ) {
          categorizedData.alias.event.push(item);
          categorizedData.alias.event?.sort((a, b) =>
            a.label.localeCompare(b.label),
          );
        }
      }
    } else if (item.type === "fluxdata") {
      categorizedData.fluxdata.push(item);
      categorizedData.fluxdata?.sort((a, b) => a.label.localeCompare(b.label));
    }
  });
  const upadtedcategorizedData = updateAliasMetadataGroup(
    categorizedData,
    auth,
  );
  return upadtedcategorizedData;
}

function extractRelevantFields(obj) {
  return {
    collectorIcon: obj.collectorIcon ?? null,
    collectorId: obj.collectorId ?? null,
    collectorName: obj.collectorName ?? null,
    configId: obj.configId ?? null,
    configName: obj.configName ?? null,
    selected: obj.selected,
    mediaType: obj.mediaType ?? "not_appl",
    dataPointId: obj.dataPointId ?? null,
    pluginIcon: obj.pluginIcon,
    pluginId: obj.pluginId,
    pluginName: obj.pluginName,
    collectorType: obj.collectorType,
    adFrameworkName: obj.adFrameworkName,
  };
}

function removeUnwantedFields(obj) {
  const {
    companyId,
    companyName,
    deprecated,
    disabled,
    hideFromCustomer,
    ...filteredObj
  } = obj;
  return filteredObj;
}

function updateAliasMetadataGroup(categorizedData, auth) {
  let { applicationMetadata = [], cdnMetadata = [] } = categorizedData.metadata;

  applicationMetadata.forEach((item) => {
    if (item.type === "metadata" && item.section === "alias") {
      item.group = "Custom Metadata";
    }
  });

  cdnMetadata.forEach((item) => {
    if (item.type === "metadata" && item.section === "alias") {
      item.group = "Custom Metadata";
    }
  });

  const isCustomDataDisabled =
    process.env.REACT_APP_CUSTOM_DATA === "false" ||
    auth?.user?.roleName !== SUPER_ADMIN_ROLE;
  if (isCustomDataDisabled) {
    applicationMetadata = applicationMetadata.filter(
      (item) => item.section?.toLowerCase() !== "alias",
    );
    cdnMetadata = cdnMetadata.filter(
      (item) => item.section?.toLowerCase() !== "alias",
    );
  }

  if (
    process.env.REACT_APP_CUSTOM_DATA === "true" &&
    auth?.user?.roleName === SUPER_ADMIN_ROLE
  ) {
    applicationMetadata.forEach((item) => {
      if (item.type === "Custom") {
        item.section = "alias";
        item.label = "All Unmapped Keys";
        item.group = "Custom Metadata";
      }
    });

    cdnMetadata.forEach((item) => {
      if (item.type === "Custom") {
        item.section = "alias";
        item.label = "All Unmapped Keys";
        item.group = "Custom Metadata";
      }
    });
  }

  if (
    process.env.REACT_APP_CUSTOM_DATA === "true" &&
    auth?.user?.roleName === SUPER_ADMIN_ROLE
  ) {
    // Update label for custom event items
    categorizedData.event = (categorizedData.event || []).map((item) => {
      if (item.type === "event" && item.originalType === "Custom") {
        return {
          ...item,
          label: "All Unmapped Keys",
        };
      }
      return item;
    });
  }

  categorizedData.metadata.applicationMetadata = applicationMetadata;
  categorizedData.metadata.cdnMetadata = cdnMetadata;
  return categorizedData;
}

function moveAliasMetadataItems(categorizedData) {
  const { applicationMetadata = [], cdnMetadata = [] } =
    categorizedData.metadata;

  const aliasApplication = applicationMetadata.filter(
    (item) => item.section === "alias",
  );
  const remainingApplication = applicationMetadata.filter(
    (item) => item.section !== "alias",
  );

  const aliasCdn = cdnMetadata.filter((item) => item.section === "alias");
  const remainingCdn = cdnMetadata.filter((item) => item.section !== "alias");

  categorizedData.metadata.applicationMetadata = remainingApplication;
  categorizedData.metadata.cdnMetadata = remainingCdn;
  categorizedData.alias.metaData.applicationMetadata.push(...aliasApplication);
  categorizedData.alias.metaData.cdnMetadata.push(...aliasCdn);

  return categorizedData;
}

function filterMetadataBySection(metadataArray, section, configId, event) {
  if (!Array.isArray(metadataArray)) return [];

  const isValidUUID =
    /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

  return metadataArray
    .filter(
      (item) =>
        item.section === section &&
        (!item.originalType ||
          (item.originalType !== "Custom" && item.originalType !== "Vendor")),
    )
    .flatMap((item) => {
      if (Array.isArray(item.additional_info) && item.type === "event") {
        return item.additional_info
          .filter((info) => {
            const isIncluded = info.configIds?.includes(configId);
            const isException = item.exception_list?.some(
              (ex) =>
                ex.configId === configId && ex.dataPointId === info.dataPointId,
            );
            return isIncluded && !isException;
          })
          .map((info) => {
            let dataPointId = info?.dataPointId;
            if (!dataPointId || !isValidUUID.test(dataPointId)) {
              dataPointId = item?.additional_info?.[0]?.dataPointId;
              if (!dataPointId || !isValidUUID.test(dataPointId)) {
                dataPointId =
                  item?.additional_info?.[1]?.dataPointId ||
                  item?.datapointsList?.[0]?.id;
              }
            }

            if (!dataPointId || !isValidUUID.test(dataPointId)) return null;

            const existsInCurrent = Array.isArray(event)
              ? event.some((e) =>
                  isValidUUID.test(e?.dataPointId) === true
                    ? e?.dataPointId === dataPointId
                    : e?.datapointsList?.[0]?.id === dataPointId,
                )
              : false;

            if (!existsInCurrent) return null;

            // Find matching include entry
            const matchedInclude = item.includes_list?.find(
              (inc) =>
                inc.configId === configId && inc.dataPointId === dataPointId,
            );

            return {
              ...item,
              dataPointId,
              name: info.name,
              label: info.label,
              required: info.required,
              selected: matchedInclude?.selected ?? info.selected ?? false,
              selectedMediaTypes: item?.selectedMediaTypes,
              mediaType: info.mediaType,
              dataPointList: info?.dataPointList,
            };
          })
          .filter(Boolean); // Remove nulls
      }

      // Handle non-event metadata
      const isIncluded = item.includes_list?.some(
        (include) =>
          include.configId === configId &&
          include.dataPointId === item.dataPointId,
      );
      const isException = item.exception_list?.some(
        (ex) => ex.configId === configId && ex.dataPointId === item.dataPointId,
      );

      if (isIncluded && !isException) {
        const matchingInclude = item.includes_list.find(
          (include) =>
            include.configId === configId &&
            include.dataPointId === item.dataPointId,
        );
        return [
          {
            ...item,
            selected: matchingInclude?.selected ?? false,
          },
        ];
      }

      return [];
    })
    .map((item) => {
      const { includes_list, exception_list, ...rest } = item;
      return rest;
    });
}

function extractCustomAndVendorItems(
  categorizedData,
  type,
  configId,
  collectorItems = [],
) {
  const collectorIds = new Set(
    collectorItems.map((ci) => ci?.dataPointId).filter(Boolean),
  );

  const seenIds = new Set();

  const allItems = [
    ...(categorizedData?.metadata?.applicationMetadata || []),
    ...(categorizedData?.metadata?.cdnMetadata || []),
    ...(categorizedData?.event || []),
    ...(categorizedData?.fluxdata || []),
  ];

  for (const item of allItems) {
    const id = item?.dataPointId;
    const isCustom = type === "custom" && item.originalType === "Custom";
    const isVendor = type === "vendor" && item.originalType === "Vendor";
    if (!isCustom && !isVendor) continue;

    const isIncluded = item?.includes_list?.some(
      (inc) =>
        inc?.configId === configId &&
        (inc?.selected === true || inc?.required === true),
    );

    const isException = item?.exception_list?.some(
      (exc) => exc?.configId === configId,
    );

    if (id && isIncluded && !isException && collectorIds.has(id)) {
      seenIds.add(id);
    }
  }

  return Array.from(seenIds).map((id) => ({ id }));
}

function expandItemsByDatapointsList(items) {
  return items.flatMap((item) => {
    if (
      Array.isArray(item?.datapointsList) &&
      item?.datapointsList?.length > 1
    ) {
      return item.datapointsList.map((dp) => ({
        ...item,
        dataPointId: dp?.id,
        mediaType: dp?.mediaTypeName,
        selected: dp?.selected,
        datapointsList: [dp],
      }));
    }
    return [item];
  });
}

export function revertToOriginalStructure(
  currentCollectorConfigs,
  categorizedData,
) {
  if (!categorizedData || !Array.isArray(currentCollectorConfigs)) return null;
  return {
    collectorConfigs: currentCollectorConfigs.map((collector) => {
      const configId = collector.configId;
      return {
        ...collector,
        general: {
          ...collector.general,
          eventList: filterMetadataBySection(
            categorizedData.event,
            "general",
            configId,
            collector?.general?.eventList,
          ),
          fluxDataList: filterMetadataBySection(
            categorizedData.fluxdata,
            "general",
            configId,
          ),
          metaDataList: filterMetadataBySection(
            [
              ...(categorizedData?.metadata?.applicationMetadata || []),
              ...(categorizedData?.metadata?.cdnMetadata || []),
            ],
            "general",
            configId,
          ),
        },
        mediaPlayer: {
          eventList: filterMetadataBySection(
            categorizedData?.event,
            "mediaplayer",
            configId,
            collector?.mediaPlayer?.eventList,
          ),
          fluxDataList: filterMetadataBySection(
            categorizedData?.fluxdata,
            "mediaplayer",
            configId,
          ),
          metaDataList: filterMetadataBySection(
            [
              ...(categorizedData?.metadata?.applicationMetadata || []),
              ...(categorizedData?.metadata?.cdnMetadata || []),
            ],
            "mediaplayer",
            configId,
          ),
        },
        custom: extractCustomAndVendorItems(
          categorizedData,
          "custom",
          configId,
          collector?.custom,
        ),
        alias: {
          event: extractAliasItem(
            categorizedData?.alias?.event,
            configId,
            "event",
          ),
          metadata: extractAliasItem(
            collector?.collectorType === "CDN"
              ? categorizedData?.metadata?.cdnMetadata
              : categorizedData?.metadata?.applicationMetadata,
            configId,
            "metadata",
          ),
        },
        vendor: extractCustomAndVendorItems(
          categorizedData,
          "vendor",
          configId,
          collector?.vendor,
        ),
      };
    }),
  };
}

function extractAliasItem(metadataArray, configId, type) {
  if (!Array.isArray(metadataArray)) return [];

  return metadataArray
    .filter((item) => item?.section === "alias" && item?.type !== "Custom")
    .flatMap((item) => {
      const isTopLevelExcluded = item.exception_list?.some(
        (exc) =>
          exc.configId === configId &&
          (exc.dataPointId === null || exc.dataPointId === item.dataPointId),
      );

      if (isTopLevelExcluded) return [];

      if (type === "event" && Array.isArray(item.additional_info)) {
        return item.additional_info
          .filter((info) => info.configIds?.includes(configId))
          .map((info) => {
            const isInfoExcluded = item.exception_list?.some(
              (exc) =>
                exc.configId === configId &&
                (exc.dataPointId === null ||
                  exc.dataPointId === info.dataPointId),
            );

            if (isInfoExcluded) return null;

            const matchedInclude = item.includes_list?.find(
              (inc) =>
                inc.configId === configId &&
                inc.dataPointId === info.dataPointId,
            );

            return {
              ...item,
              dataPointId: info.dataPointId,
              name: info.name,
              label: info.label,
              required: info.required,
              selected: matchedInclude?.selected ?? info.selected ?? false,
            };
          })
          .filter(Boolean);
      }

      const matchedInclude = item.includes_list?.find(
        (inc) =>
          inc.configId === configId && inc.dataPointId === item.dataPointId,
      );

      return [
        {
          ...item,
          selected: matchedInclude?.selected ?? item.selected ?? false,
        },
      ];
    })
    .map(({ includes_list, exception_list, ...rest }) => rest);
}

export function getSelectedItemsFromCollectors(collectorConfigs, pipeUpdate) {
  const collectorConfigsArray = Object.values(collectorConfigs);
  return collectorConfigsArray[0].map((collectorConfig) => {
    const selectedCollectorConfig = {
      configId: collectorConfig.configId,
    };

    // --- general section ---
    if (collectorConfig.general) {
      const general = {};
      if (Array.isArray(collectorConfig.general.eventList)) {
        general.events = collectorConfig.general.eventList
          .filter((item) => item?.selected || item?.required)
          .map((item) => ({
            id: item?.dataPointId,
            selectedMediaType:
              item?.mediaType ||
              item?.datapointsList?.[0]?.mediaTypeName ||
              item?.additional_info?.[0]?.mediaType,
          }));
      }

      if (Array.isArray(collectorConfig.general.fluxDataList)) {
        general.fluxdata = collectorConfig.general.fluxDataList
          .filter((item) => item?.selected || item?.required)
          .map((item) => ({ id: item.dataPointId }));
      }

      if (Array.isArray(collectorConfig.general.metaDataList)) {
        general.metadata = collectorConfig.general.metaDataList
          .filter((item) => item?.selected || item?.required)
          .map((item) => ({ id: item.dataPointId }));
      }

      selectedCollectorConfig.general = general;
    }

    // --- mediaPlayer section ---
    if (collectorConfig.mediaPlayer) {
      const mediaPlayer = {};

      if (Array.isArray(collectorConfig.mediaPlayer.eventList)) {
        mediaPlayer.events = collectorConfig.mediaPlayer.eventList
          .filter((item) => item?.selected || item?.required)
          .map((item) => ({
            id: item?.dataPointId,
            selectedMediaType:
              item?.mediaType ||
              item?.datapointsList?.[0]?.mediaTypeName ||
              item?.additional_info?.[0]?.mediaType,
          }));
      }

      if (Array.isArray(collectorConfig.mediaPlayer.fluxDataList)) {
        mediaPlayer.fluxdata = collectorConfig.mediaPlayer.fluxDataList
          .filter((item) => item?.selected || item?.required)
          .map((item) => ({ id: item.dataPointId }));
      }

      if (Array.isArray(collectorConfig.mediaPlayer.metaDataList)) {
        mediaPlayer.metadata = collectorConfig.mediaPlayer.metaDataList
          .filter((item) => item?.selected || item?.required)
          .map((item) => ({ id: item.dataPointId }));
      }

      // Only include mediaPlayer if it has data
      if (
        (mediaPlayer.events && mediaPlayer.events.length > 0) ||
        (mediaPlayer.fluxdata && mediaPlayer.fluxdata.length > 0) ||
        (mediaPlayer.metadata && mediaPlayer.metadata.length > 0)
      ) {
        selectedCollectorConfig.mediaPlayer = mediaPlayer;
      }
    }

    // --- custom section ---
    if (Array.isArray(collectorConfig.custom)) {
      if (collectorConfig.custom?.length > 0) {
        selectedCollectorConfig.custom = collectorConfig?.custom;
      }
    }

    // --- vendor section ---
    if (Array.isArray(collectorConfig.vendor)) {
      if (collectorConfig.vendor.length > 0) {
        selectedCollectorConfig.vendor = collectorConfig?.vendor;
      }
    }

    // Alias section
    if (collectorConfig.alias) {
      const customDetectedDataPoint = {};

      if (Array.isArray(collectorConfig.alias.event)) {
        customDetectedDataPoint.event = collectorConfig.alias.event
          .filter((item) => item?.selected || item?.required)
          .map((item) => ({ id: item.dataPointId }));
      }

      if (Array.isArray(collectorConfig.alias.metadata)) {
        customDetectedDataPoint.metadata = collectorConfig.alias.metadata
          .filter((item) => item?.selected || item?.required)
          .map((item) => ({ id: item.dataPointId }));
      }

      // Only include alias if it has data
      if (
        (customDetectedDataPoint.event &&
          customDetectedDataPoint.event.length > 0) ||
        (customDetectedDataPoint.metadata &&
          customDetectedDataPoint.metadata.length > 0)
      ) {
        selectedCollectorConfig.alias = customDetectedDataPoint;
      }
    }

    return selectedCollectorConfig;
  });
}

export function getSelectedItemsFromCollectorsForCreate(
  collectorConfigs,
  create,
) {
  return collectorConfigs?.map((collectorConfig) => {
    const selectedCollectorConfig = {
      configId: collectorConfig.configId,
    };
    const general = {};
    if (collectorConfig.general) {
      if (Array.isArray(collectorConfig.general.eventList)) {
        general.eventsList = collectorConfig.general.eventList
          .filter((item) => item && Array.isArray(item.datapointsList))
          .flatMap((item) =>
            item.datapointsList.map((dp) => ({
              id: dp?.id || dp.dataPointId,
              selectedMediaType: dp?.mediaTypeName,
            })),
          );
      }

      if (Array.isArray(collectorConfig.general.fluxDataList)) {
        general.fluxDataList = collectorConfig.general.fluxDataList
          .filter((item) => item?.name)
          .map((item) => ({ id: item.dataPointId }));
      }

      if (Array.isArray(collectorConfig.general.metaDataList)) {
        general.metaDataList = collectorConfig.general.metaDataList
          .filter((item) => item?.name)
          .map((item) => ({ id: item.dataPointId }));
      }
    }
    selectedCollectorConfig.general = general;
    // --- mediaPlayer section ---
    if (collectorConfig.mediaPlayer) {
      const mediaPlayer = {};

      if (Array.isArray(collectorConfig.mediaPlayer.eventList)) {
        mediaPlayer.eventsList = collectorConfig.mediaPlayer.eventList
          .filter((item) => item && Array.isArray(item.datapointsList))
          .flatMap((item) =>
            item.datapointsList.map((dp) => ({
              id: dp?.id || dp.dataPointId,
              selectedMediaType: dp?.mediaTypeName,
            })),
          );
      }

      if (Array.isArray(collectorConfig.mediaPlayer.fluxDataList)) {
        mediaPlayer.fluxDataList = collectorConfig.mediaPlayer.fluxDataList
          .filter((item) => item?.name)
          .map((item) => ({ id: item.dataPointId }));
      }

      if (Array.isArray(collectorConfig.mediaPlayer.metaDataList)) {
        mediaPlayer.metaDataList = collectorConfig.mediaPlayer.metaDataList
          .filter((item) => item?.name)
          .map((item) => ({ id: item.dataPointId }));
      }

      // Only include mediaPlayer if it has data
      if (
        (mediaPlayer.eventsList && mediaPlayer.eventsList.length > 0) ||
        (mediaPlayer.fluxDataList && mediaPlayer.fluxDataList.length > 0) ||
        (mediaPlayer.metaDataList && mediaPlayer.metaDataList.length > 0)
      ) {
        selectedCollectorConfig.mediaPlayer = mediaPlayer;
      }
    }

    // --- custom section ---
    if (
      Array.isArray(collectorConfig.custom) &&
      collectorConfig.custom.length > 0
    ) {
      selectedCollectorConfig.custom = collectorConfig.custom.map((item) => ({
        id: item.dataPointId,
      }));
    }

    // --- vendor section ---
    if (
      Array.isArray(collectorConfig.vendor) &&
      collectorConfig.vendor.length > 0
    ) {
      selectedCollectorConfig.vendor = collectorConfig.vendor.map((item) => ({
        id: item.dataPointId,
      }));
    }

    // Alias section
    if (collectorConfig.alias) {
      const customDetectedDataPoint = {};

      if (Array.isArray(collectorConfig.alias.events)) {
        customDetectedDataPoint.event = collectorConfig.alias.events
          .filter((item) => item?.name)
          .map((item) => ({ id: item.dataPointId }));
      }

      if (Array.isArray(collectorConfig.alias.metadata)) {
        customDetectedDataPoint.metadata = collectorConfig.alias.metadata
          .filter((item) => item?.name)
          .map((item) => ({ id: item.dataPointId }));
      }

      // Only include alias if it has data
      if (
        (customDetectedDataPoint.event &&
          customDetectedDataPoint.event.length > 0) ||
        (customDetectedDataPoint.metadata &&
          customDetectedDataPoint.metadata.length > 0)
      ) {
        selectedCollectorConfig.alias = customDetectedDataPoint;
      }
    }
    return selectedCollectorConfig;
  });
}

export function getSelectedItemsFromCollectorsForTabZeroUpdate(
  collectorConfigs,
  create,
) {
  return collectorConfigs?.map((collectorConfig) => {
    const selectedCollectorConfig = {
      configId: collectorConfig.configId,
    };

    // --- general section ---
    if (collectorConfig.general) {
      const general = {};
      if (Array.isArray(collectorConfig.general.eventList)) {
        general.events = collectorConfig.general.eventList.flatMap((item) => {
          if (Array.isArray(item.datapointsList)) {
            return item.datapointsList
              .filter((dp) => dp?.selected || dp?.required)
              .map((dp) => ({
                id: dp?.id || dp?.dataPointId,
                selectedMediaType: dp?.mediaTypeName,
              }));
          }

          if (item?.selected || item?.required) {
            return [
              {
                id: item?.dataPointId,
                selectedMediaType:
                  item?.mediaType ||
                  item?.datapointsList?.[0]?.mediaTypeName ||
                  item?.additional_info?.[0]?.mediaType,
              },
            ];
          }

          return [];
        });
      }

      if (Array.isArray(collectorConfig.general.fluxDataList)) {
        general.fluxdata = collectorConfig.general.fluxDataList
          .filter((item) => item?.selected || item?.required)
          .map((item) => ({ id: item.dataPointId }));
      }

      if (Array.isArray(collectorConfig.general.metaDataList)) {
        general.metadata = collectorConfig.general.metaDataList
          .filter((item) => item?.selected || item?.required)
          .map((item) => ({ id: item.dataPointId }));
      }

      selectedCollectorConfig.general = general;
    }

    // --- mediaPlayer section ---
    if (collectorConfig.mediaPlayer) {
      const mediaPlayer = {};

      if (Array.isArray(collectorConfig.mediaPlayer.eventList)) {
        mediaPlayer.events = collectorConfig.mediaPlayer.eventList.flatMap(
          (item) => {
            if (Array.isArray(item.datapointsList)) {
              return item.datapointsList
                .filter((dp) => dp?.selected || dp?.required)
                .map((dp) => ({
                  id: dp?.id || dp?.dataPointId,
                  selectedMediaType: dp?.mediaTypeName,
                }));
            }

            if (item?.selected || item?.required) {
              return [
                {
                  id: item?.dataPointId,
                  selectedMediaType:
                    item?.mediaType ||
                    item?.datapointsList?.[0]?.mediaTypeName ||
                    item?.additional_info?.[0]?.mediaType,
                },
              ];
            }

            return [];
          },
        );
      }

      if (Array.isArray(collectorConfig.mediaPlayer.fluxDataList)) {
        mediaPlayer.fluxdata = collectorConfig.mediaPlayer.fluxDataList
          .filter((item) => item?.selected || item?.required)
          .map((item) => ({ id: item.dataPointId }));
      }

      if (Array.isArray(collectorConfig.mediaPlayer.metaDataList)) {
        mediaPlayer.metadata = collectorConfig.mediaPlayer.metaDataList
          .filter((item) => item?.selected || item?.required)
          .map((item) => ({ id: item.dataPointId }));
      }

      // Only include mediaPlayer if it has data
      if (
        (mediaPlayer.events && mediaPlayer.events.length > 0) ||
        (mediaPlayer.fluxdata && mediaPlayer.fluxdata.length > 0) ||
        (mediaPlayer.metadata && mediaPlayer.metadata.length > 0)
      ) {
        selectedCollectorConfig.mediaPlayer = mediaPlayer;
      }
    }

    // --- custom section ---
    if (
      Array.isArray(collectorConfig.custom) &&
      collectorConfig.custom.length > 0
    ) {
      const selectedCustom = collectorConfig.custom
        .filter((item) => item.selected || item.required)
        .map((item) => ({
          id: item.dataPointId,
        }));

      if (selectedCustom?.length > 0) {
        selectedCollectorConfig.custom = selectedCustom;
      }
    }

    // --- vendor section ---
    if (
      Array.isArray(collectorConfig.vendor) &&
      collectorConfig.vendor.length > 0
    ) {
      const selectedVendor = collectorConfig.vendor
        .filter((item) => item.selected || item.required)
        .map((item) => ({
          id: item.dataPointId,
        }));

      if (selectedVendor?.length > 0) {
        selectedCollectorConfig.vendor = selectedVendor;
      }
    }

    // Alias section
    if (collectorConfig.alias) {
      const customDetectedDataPoint = {};

      if (Array.isArray(collectorConfig.alias.events)) {
        customDetectedDataPoint.event = collectorConfig.alias.events
          .filter((item) => item?.selected || item?.required)
          .map((item) => ({ id: item.dataPointId }));
      }

      if (Array.isArray(collectorConfig.alias.metadata)) {
        customDetectedDataPoint.metadata = collectorConfig.alias.metadata
          .filter((item) => item?.selected || item?.required)
          .map((item) => ({ id: item.dataPointId }));
      }

      // Only include alias if it has data
      if (
        (customDetectedDataPoint.event &&
          customDetectedDataPoint.event.length > 0) ||
        (customDetectedDataPoint.metadata &&
          customDetectedDataPoint.metadata.length > 0)
      ) {
        selectedCollectorConfig.alias = customDetectedDataPoint;
      }
    }
    return selectedCollectorConfig;
  });
}
export const getUniqueMetadataCount = (data) => {
  const allMetadata = [
    ...(data?.allMetadata || []),
    ...(data?.applicationMetadata || []),
    ...(data?.cdnMetadata || []),
  ];

  const uniqueSet = new Set();

  allMetadata?.forEach((item) => {
    const name = item?.name;
    const groupOrType = item?.group || item?.type;
    const isRequired = item?.required;
    const includesSelected = item?.includes_list?.some((i) => i?.selected);
    if ((isRequired || includesSelected) && name && groupOrType) {
      const key = JSON.stringify({ name, group: groupOrType });
      uniqueSet.add(key);
    }
  });

  return uniqueSet?.size || 0;
};

export const getUniqueFluxdataCount = (data) => {
  const uniqueSet = new Set();
  data?.forEach((item) => {
    const name = item?.dataPointId;
    const isRequired = item?.required;
    const includesSelected = item?.includes_list?.some((i) => i?.selected);
    if ((isRequired || includesSelected) && name) {
      uniqueSet.add(name);
    }
  });

  return uniqueSet?.size || 0;
};

export const getSelectedUniqueEventsCount = (...eventList) => {
  const uniqueSet = new Set();
  eventList?.forEach((item) => {
    const name = item?.name;
    const isRequired = item?.required;
    const includesSelected = item?.includes_list?.some((i) => i?.selected);
    const additionalInfoSelected = item?.additional_info?.some(
      (i) => i?.selected,
    );

    if ((isRequired || includesSelected || additionalInfoSelected) && name) {
      uniqueSet.add(name);
    }
  });

  return uniqueSet?.size || 0;
};

function filterCollectorListsByType(item, type) {
  const isAppType = type === "application";
  const shouldKeep = (collector) =>
    isAppType
      ? collector?.collectorType === "APP_COLLECTOR"
      : collector?.collectorType === "CDN";
  const filteredIncludes = item?.includes_list?.filter(shouldKeep);
  const filteredExceptions = item?.exception_list?.filter(shouldKeep);
  const anySelectedOrRequired = filteredIncludes?.some(
    (entry) => entry?.selected === true || entry?.required === true,
  );
  return {
    ...item,
    includes_list: filteredIncludes,
    exception_list: filteredExceptions,
    selected: anySelectedOrRequired,
  };
}

// Utility function to update item selection based on matching criteria
const updateSelectionStatus = (itemsList, referenceData) => {
  if (itemsList?.length > 0 && referenceData?.length > 0) {
    itemsList.forEach((item) => {
      const match = referenceData.find(
        (dp) => dp.dataPointId === item.dataPointId && !dp.required,
      );
      if (match) {
        item.selected = match.selected;
      }
    });
  }
};

const updateCustomOrVendorSelectionStatus = (itemsList, referenceData) => {
  if (Array.isArray(itemsList) && Array.isArray(referenceData)) {
    itemsList.forEach((item) => {
      const match = referenceData.find(
        (dp) => dp.dataPointId === item.dataPointId && !dp.required,
      );
      if (match) {
        item.selected = match.selected;
      }
    });
  }
};

// Main function
export const updateSelecteionOnCollectorAddInAllSections = (
  currentCollectorConfigs,
  player,
  auth,
) => {
  const datapoints = extractLists(
    currentCollectorConfigs,
    {},
    "general",
    true,
    auth,
  );
  // Events section
  updateAllEventDatapointsSelection(player, datapoints);
  // fluxdata general section
  updateSelectionStatus(player?.general?.fluxDataList, datapoints?.fluxdata);
  // fluxdata mediaplayer section
  updateSelectionStatus(
    player?.mediaPlayer?.fluxDataList,
    datapoints?.fluxdata,
  );
  // metdata general and mediaplayer section app collector
  updateSelectionStatus(player?.general?.metaDataList, [
    ...datapoints.metadata.applicationMetadata,
    ...datapoints.metadata.cdnMetadata,
  ]);
  updateSelectionStatus(player?.mediaPlayer?.metaDataList, [
    ...datapoints.metadata.applicationMetadata,
    ...datapoints.metadata.cdnMetadata,
  ]);
  // update custom selection status
  updateCustomOrVendorSelectionStatus(player?.custom, [
    ...datapoints.event,
    ...datapoints.metadata.applicationMetadata,
    ...datapoints.metadata.cdnMetadata,
  ]);
  // update vendor selection status
  updateCustomOrVendorSelectionStatus(player?.vendor, [
    ...datapoints.event,
    ...datapoints.metadata.applicationMetadata,
    ...datapoints.metadata.cdnMetadata,
  ]);
  // update alias event selection status
  updateSelectionStatus(player?.alias?.events, datapoints?.alias?.event);
  // update alias metdata  selection status
  updateSelectionStatus(player?.alias?.metadata, [
    ...datapoints.metadata.applicationMetadata,
    ...datapoints.metadata.cdnMetadata,
  ]);
  return player;
};

const updateAllEventDatapointsSelection = (player, datapoints) => {
  const sections = ["general", "mediaPlayer"];
  sections.forEach((section) => {
    const eventList = player?.[section]?.eventList;
    if (Array.isArray(eventList) && Array.isArray(datapoints?.event)) {
      eventList.forEach((eventItem) => {
        if (Array.isArray(eventItem.datapointsList)) {
          eventItem.datapointsList.forEach((dpItem) => {
            const match = datapoints.event.find(
              (dp) =>
                Array.isArray(dp.additional_info) &&
                dp.additional_info.some(
                  (info) => info.dataPointId === dpItem.id,
                ),
            );
            if (match) {
              const matchedInfo = match.additional_info.find(
                (info) => info.dataPointId === dpItem.id,
              );

              if (matchedInfo) {
                dpItem.selected = matchedInfo.selected;
                eventItem.selected = matchedInfo.selected;
              }
            }
            if (dpItem?.required || dpItem?.selected) {
              eventItem.selected = true;
            }
          });
        }
      });
    }
  });
};
